import MatchingExercise from "./MatchingExercise";
import ClassificationExercise from "./ClassificationExercise";
import TrueFalseExercise from "./TrueFalseExercise";
import FillBlankExercise from "./FillBlankExercise";
import MultipleChoiceExercise from "./MultipleChoiceExercise";
import FlashcardExercise from "./FlashcardExercise";
import SequenceExercise from "./SequenceExercise";

export default function LearningExercise({
  exercise,
  submittingLearningExercise,
  submitLearningExercise,
  styles,
}) {
  if (!exercise) return null;

  if (exercise.exercise_type === "matching") {
    return (
      <MatchingExercise
        exercise={exercise}
        submittingLearningExercise={
          submittingLearningExercise
        }
        submitLearningExercise={
          submitLearningExercise
        }
        styles={styles}
      />
    );
  }

  if (
    exercise.exercise_type === "classification"
  ) {
    return (
      <ClassificationExercise
        exercise={exercise}
        submittingLearningExercise={
          submittingLearningExercise
        }
        submitLearningExercise={
          submitLearningExercise
        }
        styles={styles}
      />
    );
  }

  if (exercise.exercise_type === "true_false") {
    return (
      <TrueFalseExercise
        exercise={exercise}
        submittingLearningExercise={
          submittingLearningExercise
        }
        submitLearningExercise={
          submitLearningExercise
        }
        styles={styles}
      />
    );
  }

  if (exercise.exercise_type === "fill_blank") {
    return (
      <FillBlankExercise
        exercise={exercise}
        submittingLearningExercise={
          submittingLearningExercise
        }
        submitLearningExercise={
          submitLearningExercise
        }
        styles={styles}
      />
    );
  }

  if (
    exercise.exercise_type === "multiple_choice"
  ) {
    return (
      <MultipleChoiceExercise
        exercise={exercise}
        submittingLearningExercise={
          submittingLearningExercise
        }
        submitLearningExercise={
          submitLearningExercise
        }
        styles={styles}
      />
    );
  }

  if (exercise.exercise_type === "flashcard") {
    return (
      <FlashcardExercise
        exercise={exercise}
        submittingLearningExercise={
          submittingLearningExercise
        }
        submitLearningExercise={
          submitLearningExercise
        }
        styles={styles}
      />
    );
  }

  if (exercise.exercise_type === "sequence") {
    return (
      <SequenceExercise
        exercise={exercise}
        submittingLearningExercise={
          submittingLearningExercise
        }
        submitLearningExercise={
          submitLearningExercise
        }
        styles={styles}
      />
    );
  }

  return (
    <div style={styles.emptyBox}>
      Exercise type "{exercise.exercise_type}" is not supported yet.
    </div>
  );
}